
declare var window:any

// import Backbone from 'backbone'
const Backbone = require('backbone')
const _ = require('underscore')
const Mustache = require('mustache')
const {MenuAmbienteController} = require('../../controllers/orcamento/menuAmbientesController')
const {VendaProdutoEstoqueIndisponivel} = require('../../controllers/orcamento/vendaProdutoEstoqueIndisponivel')
const {LotesProdutoController} = require('../../controllers/orcamento/lotesProdutoController')
import { HelloReact } from 'app/components/HelloReact'
import {MenuConsultaProdutosController} from 'app/controllers/orcamento/menuConsultaProdutosController'
const {parametroSistema} = require('../../controllers/parametros/parametroController')
import {Ambientes} from 'app/models/orcamento/ambiente'

import global from 'globalMU'
import ReactDOM from 'react-dom'
import React from 'react'

window.$boolSelecionarTodosItensOrcamento = false;
window.$elementoComFocoEdicaoQuantidadeItemGrid = null;
window.$IndexEdicaoQuantidadeItemGrid = null;
window.$elementoComFocoEdicaoPrecoUnitItemGrid = null;
window.$IndexEdicaoPrecoUniItemGrid = null;
window.$elementoComFocoEdicaoCentroCustoItemGrid = null;
window.$IndexEdicaoCentroCustoItemGrid = null;
window.$elementoComFocoEdicaoPedidoCompraItemGrid = null;
window.$IndexEdicaoPedidoCompraItemGrid = null;
window.$elementoComFocoEdicaoMarkUpItemGrid = null;
window.$IndexEdicaoMarkUpItemGrid = null;
window.$elementoComFocoEdicaoLinhaOrdemCompraItemGrid = null;
window.$IndexEdicaoLinhaOrdemCompraItemGrid = null;
//
//var $elementoComFocoEdicaoFilialRetiradaItemGrid = null; /*FNX-5270*/
//var $IndexEdicaoFilialRetiradaItemGrid = null; /*FNX-5270*/
//var $elementoComFocoEdicaoFilialTransferenciaItemGrid = null; /*FNX-5270*/
//var $IndexEdicaoFilialTransferenciaItemGrid = null; /*FNX-5270*/
//var $elementoComFocoEdicaoTipoFatItemGrid = null; /*FNX-5270*/
//var $IndexEdicaoTipoFatItemGrid = null; /*FNX-5270*/

//
var $modelSobEncomendaGridItens = null;
var usuarioLogado = global.sessionStorage.getData('UsuarioLogado');

import {hackCorrigirProblemaAposSelecaoDeItens} from '../../../fixarGridItens'
import store from 'app/redux/store/store'
import {atualizarItemAction, sobrescreverInformacoesAction} from 'app/redux/orcamentoSlice'
import { GridController } from 'gridController'

const ItemOrcamentoItemView = Backbone.Marionette.ItemView.extend({
    name: "ItemOrcamentoItemView",
    template: "#template-itens-orcamento-item",
    tagName: "tr",
    className: "clicavel",

    events: {
        'click td.selecionavel': "selecionarItem",
        'click a[editar]': "editarItem",
        'click a[info]': "showInfo",
        'click .ambiente-col': "mostrarAmbientes",
        //'click .centro-custo-col': "mostrarCentroCustos",
        'click a[abrirSubItens]': "mostrarSubItens",
        'click a[lote]': "editarLotes",
        'click #venda-produto-estoque-indisponivel': "vendaProdutoEstoqueIndisponivel",
        'change select[name="centroCustoClienteInput"]': "centroCustoAlterado",
        'change select[name="filialRetiradaItemInput"]': "filialRetiradaItemAlterada", /*FNX-5270*/
        'change select[name="filialTransferenciaItemInput"]': "filialTransferenciaItemAlterada",/*FNX-5270*/
        'change select[name="tipoFaturamentoItemInput"]': "tipoFaturamentoItemAlterado",/*FNX-5270*/
        'change input[name="quantidadeInput"]': "quantidadeAlterada",
        'change input[name="precoUnitInput"]': "precoUnitarioAlterado",
        'change input[name="pedidoCompraInput"]': "pedidoCompraAlterado",
        'change input[name="OrdemItem"]': "ordemItemAlterada",
        'change input[name="percentualMarkUpInput"]': "markUpItemAlterado",
        'change input[name="linhaOrdemCompraInput"]': "linhaOrdemCompraAlterado",
    },

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.acoes = typeof options.acoes !== "undefined" ? options.acoes : true;
        this.expandido = typeof options.expandido !== "undefined" ? options.expandido : false;
        this.controller = options.controller;
        this.orcamento = options.orcamento;
        this.itemExcluidoCallback = options.itemExcluidoCallback;
        this.menuAmbientes = new MenuAmbienteController({
            region: "#menu-ambientes",
            orcamento: options.controller.model,
            model: this.model,
            itemSaved: $.proxy(this.ambienteAlterado, this),
            itemDeleted: $.proxy(this.ambienteExcluido, this),
            readOnly: this.controller.readOnly
        });
        //parametroSistema.obter("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL",
        //            $.proxy(function (p) {
        //                this.parametroOrcamentoOutrasSaidasRetiradaOutroLocal = p;
        //            },
        //        this));
        this.parametroOrcamentoOutrasSaidasRetiradaOutroLocal = this.controller.param_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL; // // FNX-4579; FNX-4604; FNX-4637 - Performance


        if (!usuarioLogado || !(usuarioLogado && usuarioLogado.CorFundo || usuarioLogado.CorTexto)) {
            usuarioLogado = { CorFundo: "#FFFFCC", CorTexto: "#000000" };
        }


    },

    vendaProdutoEstoqueIndisponivel: function (e) {

        e.preventDefault();

        if (this.orcamento && this.orcamento.get("TipoOrcamento") == 2) { // transferencia
            return
        }

        this.vendaProdutoEstoqueIndisponivel = this.controller.showView({
            region: {
                name: "vendaProdutoEstoqueIndisponiveItemOrcamentolRegion",
                selector: "#venda-produto-estoque-indisponivel-item-orcamento-region"
            },
            controller: {
                type: VendaProdutoEstoqueIndisponivel,
                args: {
                    itemOrcamento: this.model,
                    itemExcluidoCallback: $.proxy(this.itemExcluido, this)
                }
            }
        });
    },

    render: function () {
        var self = this;

        var data = {
            view: this,
            quantidade: function () {
                return global.formatNumber(this.Quantidade, 3);
            },
            precoProduto: function () {
                return global.formatMoney(this.PrecoProduto);
            },
            valorTotal: function () {
                return global.formatMoney(this.ValorTotal);
            },
            quantidadeSolicitada: function () {
                return global.formatNumber(this.QuantidadeSolicitada, 3);
            },
            precoSolTotal: function () {
                return global.formatMoney(this.PrecoSolTotal);
            },
            quantidadePendente: function () {
                return global.formatNumber(this.QuantidadePendente, 3);
            },
            precoPendenciaTotal: function () {
                return global.formatMoney(this.PrecoPendenciaTotal);
            },
            cor: function () {
                if (!this.view) {
                    return null;
                }

                if (typeof this.Ambiente == "undefined" || !this.Ambiente) {
                    return this.view.menuAmbientes.undefinedColor;
                }

                return this.view.menuAmbientes.getColor(this.Ambiente);
            },
            ambiente: function () {
                if (this.Classe == "Itempedidovendasubordinado") return "";
                return typeof this.Ambiente !== "undefined" && this.Ambiente ? this.Ambiente : "Definir";
            },
            dataPrevisaoEntrega: function () {
                return global.formatDate(this.DataPrevisaoEntrega);
            },
            dataMarcadaEntrega: function () {
                return global.formatDate(this.DataMarcadaEntrega);
            },
            valorSubstituicao: function () {
                return global.formatNumber(this.ValorSubstituicao);
            },
            aliquotaIPI: function () {
                return global.formatNumber(this.AliquotaIPI);
            },
            valorIPI: function () {
                return global.formatNumber(this.ValorIPI);
            },
            percentualDesconto: function () {
                return global.formatNumber(this.PercentualDesconto);
            },
            percentualBonificacao: function () {
                return global.formatNumber(this.PercentualBonificacao);
            },
            percentualMarkUp: function () {
                return global.formatNumber(this.PercentualMarkUp);
            },
            podeEditar: function () {
                return this.Classe !== "Itempedidovendasubordinado";
            },
            naoPodeEditar: function () {
                return this.Classe === "Itempedidovendasubordinado";
            },
            existeImagem: function () {
                return this.Imagens && this.Imagens.length > 0;
            },
            loteOK: function () {
                return this.QuantidadeFaltante == 0 ? "icone-reservar" : "icone-reservar-faltante";
            },
            title: function () {
                return this.QuantidadeFaltante == 0 ? "Reserva de lote efetuada" : "Reserva de lote pendente";
            },
            possuiCor: function () {
                return this.Cor !== "#000000";
            },
            quantidadeIndisponivel: function () {
                return this.BloqueadoEstoque;
            },
            possuiAlerta: function () {
                return this.Alertas && this.Alertas.length > 0;
            },
            TextoTecnicoPreenchido: function () {
                return this.TextoTecnico?.trim().length > 0;
            },
            ofertaSendoPraticada: function () {
                return this.OfertaSelecionada == 1;
            },
            mostrarLocalRetirada: function () { // FNX-5270
                return this.CodigoTipoEntrega !== "C";
            },
            filialRetiradaNaoFoiDefinida: function () {// FNX-5270
                return this.CodigoFilialRetirada === undefined || this.CodigoFilialRetirada === "";
            },
            mensagemOfertaPraticada: function () {
                return 'Oferta Seletiva';
            },
            mensagemAlertas: function () {
                var mensagem = '';
                $.each(this.Alertas,
                    function () {
                        mensagem += '- ' + this.Mensagem + '&#013;';
                    });
                return mensagem;
            },
            mensagemAlertasPopOver: function () {
                var mensagem = '';
                $.each(this.Alertas,
                    function () {
                        mensagem += '- ' + this.Mensagem + '<br />';
                    });
                return mensagem;
            },
            pedidoCompra: function () {
                return this.PedidoCompra;
            }
        };

        _.extend(data, this.model.toJSON());

        if (this.model.get("Classe") == "Itempedidovendasubordinado") {
            this.$el.attr("subitem", this.model.get("CodigoTinta"));
            this.$el.attr("allowShow", false);
            this.$el.hide();
        }

        this.$el.html(Mustache.render($(this.template).html(), data));

        setTimeout($.proxy(function () {
            $('[data-toggle="popover"]')
                .click(function (e) {
                    e.preventDefault();
                });
            $('a[data-toggle="popover"]').popover({ html: true });
        },
            this),
            200);

        if (this.acoes && !this.model.OrdemAlterada) {

            if (this.model.get("selecionado")) {
                this.$el.css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
            } else {
                this.$el.css({ "background-color": '', "color": '' });
            }
        }

        if (!this.expandido) {
            $("[expandido]", this.$el).remove();
        }
        var imagens = this.model.get("Imagens");

        if (imagens && imagens.length > 0) {
            var items = [];

            $.each(imagens,
                function () {
                    items.push({
                        subHtml: this.Nome,
                        src: this.Caminho,
                        thumb: this.Caminho,
                    });
                });

            $(".icone-orcamento-imagem", this.$el).ImageGallery({
                images: items
            });

            //$('a[imagens]', this.$el).magnificPopup({
            //    tClose: 'Fechar (Esc)',
            //    items: items,
            //    gallery: {
            //        enabled: true,
            //        tPrev: 'Anterior (Tecla seta esquerda)',
            //        tNext: 'Próximo (Tecla seta direita)',
            //        tCounter: '%curr% de %total%'
            //    },
            //    type: 'image'
            //});
        }
        //this.model.set("DescricaoTipoOrcamento", this.orcamento.get("TipoOrcamentoDescricao"))
        if (this.orcamento !== undefined) {
            // this.model.set("DescricaoTipoOrcamento", this.orcamento.get("TipoOrcamentoDescricao"));
            this.model.set("TipoOrcamento", this.orcamento.get("TipoOrcamento"));
            this.model.set("OcultarRetiradaOutroLocal", this.orcamento.get("TipoOrcamentoDescricao") === "Outras Saídas" && this.parametroOrcamentoOutrasSaidasRetiradaOutroLocal && this.parametroOrcamentoOutrasSaidasRetiradaOutroLocal.Valor !== "S");
        }


        var nomeObjFilialRetirada = "#FilialRetiradaItem_" + self.model.get("Identificador"); /*FNX-5270*/
        setTimeout(function () { /*FNX-5270*/
            global.autocomplete({
                selector: nomeObjFilialRetirada,
                url: '/Orcamento/_ObterListaFiliaisItem',
                method: 'get',
                minChar: 0,
                placeholder: '',
                allowClear: true,
                ajaxData: function (params) {
                    var query = {
                        identificadorOrcamento: self.model.get("IdentificadorOrcamento"),
                        identificadorItem: self.model.get("Identificador"),
                        tipo: "RETIRADA",
                        filialPesquisa: params.term
                    };

                    return query;
                },
                processResults: function (data) {

                    if (data && data.ErrorType === "SessionExpired") {
                        global.showErrorMessage(data.Error);
                    }

                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.Descricao,
                                id: item.Codigo,
                            };
                        })
                    };
                },
                maxSelection: 1
            });
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            }).on('mouseleave', function () { $('.tooltip').tooltip('hide'); });
            $('.tooltip').on('click', function () { $('.tooltip').tooltip('hide'); });

            var $objFilialRetirada = $(nomeObjFilialRetirada);
            if (self.model && self.model.get("CodigoFilialRetirada") !== "") {
                var newOption = new Option(self.model.get("CodigoFilialRetirada"), self.model.get("CodigoFilialRetirada"), false, false);
                $($objFilialRetirada).append(newOption);
            }
        }, 1);

        var nomeObjFilialTransferencia = "#FilialTransferenciaItem_" + self.model.get("Identificador"); /*FNX-5270*/
        setTimeout(function () { /*FNX-5270*/
            global.autocomplete({
                selector: nomeObjFilialTransferencia,
                url: '/Orcamento/_ObterListaFiliaisItem',
                method: 'get',
                minChar: 0,
                placeholder: '',
                allowClear: true,
                ajaxData: function (params) {
                    var query = {
                        identificadorOrcamento: self.model.get("IdentificadorOrcamento"),
                        identificadorItem: self.model.get("Identificador"),
                        tipo: "TRANSFERENCIA",
                        filialPesquisa: params.term
                    };

                    return query;
                },
                processResults: function (data) {

                    if (data && data.ErrorType === "SessionExpired") {
                        global.showErrorMessage(data.Error);
                    }

                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.Descricao,
                                id: item.Codigo,
                            };
                        })
                    };
                },
                maxSelection: 1
            });
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            }).on('mouseleave', function () { $('.tooltip').tooltip('hide'); });
            $('.tooltip').on('click', function () { $('.tooltip').tooltip('hide'); });

            var $objFilialTransferencia = $(nomeObjFilialTransferencia);
            if (self.model && self.model.get("CodigoFilialTransferencia") !== "") {
                var newOption = new Option(self.model.get("CodigoFilialTransferencia"), self.model.get("CodigoFilialTransferencia"), false, false);
                $($objFilialTransferencia).append(newOption);
            }
        }, 1);

        var nomeObjTipoFat = "#TipoFaturamentoItemInput_" + self.model.get("Identificador"); /*FNX-5270*/
        setTimeout(function () { /*FNX-5270*/
            global.autocomplete({
                selector: nomeObjTipoFat,
                url: '/Orcamento/_ObterTipoFaturamentoItem',
                method: 'get',
                minChar: 0,
                placeholder: '',
                minimumResultsForSearch: Infinity,
                allowClear: false,
                ajaxData: function (params) {
                    var query = {
                        filialPesquisa: params.term
                    };

                    return query;
                },
                processResults: function (data) {

                    if (data && data.ErrorType === "SessionExpired") {
                        global.showErrorMessage(data.Error);
                    }

                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.Description,
                                id: item.Value,
                            };
                        })
                    };
                },
                maxSelection: 1
            });
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            }).on('mouseleave', function () { $('.tooltip').tooltip('hide'); });
            $('.tooltip').on('click', function () { $('.tooltip').tooltip('hide'); });

            var $obTipoFat = $(nomeObjTipoFat);
            if ($obTipoFat && self.model && self.model.get("TipoFaturamento") !== "") {
                var newOption = new Option(self.model.get("DescricaoTipoFaturamento"), self.model.get("CodigoTipoFaturamento"), false, false);
                $($obTipoFat).append(newOption);
            }
        }, 1);


        var nomeObjCentroCusto = "#CentroCustoItem_" + self.model.get("Identificador");
        setTimeout(function () {
            global.autocomplete({ // FNX-4253
                selector: nomeObjCentroCusto,
                url: '/Orcamento/_ObterCentroCustoCliente',
                method: 'get',
                minChar: 1,
                placeholder: '',
                allowClear: true,
                ajaxData: function (params) {
                    var query = {
                        identificadorOrcamento: self.model.get("IdentificadorOrcamento"),
                        nomeCentroCusto: params.term
                    };

                    return query;
                },
                processResults: function (data) {

                    if (data && data.ErrorType === "SessionExpired") {
                        global.showErrorMessage(data.Error);
                    }

                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.NomeCentroCusto,
                                id: item.IdClienteCentroCusto
                            };
                        })
                    };
                },
                maxSelection: 1
            });
            $('[data-toggle="tooltip"]').tooltip({
                container: 'body'
            }).on('mouseleave', function () { $('.tooltip').tooltip('hide'); });
            $('.tooltip').on('click', function () { $('.tooltip').tooltip('hide'); });

            var $objCentroCusto = $(nomeObjCentroCusto);
            if (self.model && self.model.get("IdClienteCentroCusto") > 0) {
                var newOption = new Option(self.model.get("NomeCentroCusto"), self.model.get("IdClienteCentroCusto"), false, false);
                $($objCentroCusto).append(newOption);
            }
        }, 1);


        //
        // o focus deve ser o utlimo de metodo
        $("input").on('focus', function () { $(this).select(); });
    },

    clearVariaveisPosicao: function () {
        window.$elementoComFocoEdicaoQuantidadeItemGrid = null;
        window.$elementoComFocoEdicaoPedidoCompraItemGrid = null;
        window.$IndexEdicaoPedidoCompraItemGrid = null;
        window.$IndexEdicaoQuantidadeItemGrid = null;
        window.$IndexEdicaoPrecoUniItemGrid = null;
        window.$IndexEdicaoCentroCustoItemGrid = null;
        window.$elementoComFocoEdicaoPrecoUnitItemGrid = null;
        window.$elementoComFocoEdicaoMarkUpItemGrid = null;
        window.$IndexEdicaoMarkUpItemGrid = null;
        window.$elementoComFocoEdicaoLinhaOrdemCompraItemGrid = null;
        window.$IndexEdicaoLinhaOrdemCompraItemGrid = null;
    },

    markUpItemAlterado: function (e) {
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }

        global.blockUI();
        var markUpNovo = e.target.value;


        window.$elementoComFocoEdicaoMarkUpItemGrid = $(':focus');
        window.$IndexEdicaoMarkUpItemGrid = this.model.get("Index");

        this.model.set("percentualMarkUp", markUpNovo)
    },

    precoUnitarioAlterado: function (e) {
        var self = this;
        if (e) {
            e.preventDefault();
        }

        if (!this.model.get("AtualizarRemoto")) {
            return;
        }

        var precoNovo = e.target.value;
        var precoAnterior = this.model.previous("PrecoProduto")

        this.clearVariaveisPosicao();

        window.$elementoComFocoEdicaoPrecoUnitItemGrid = $(':focus');
        window.$IndexEdicaoPrecoUniItemGrid = this.model.get("Index");


        this.model.set("PrecoProduto", precoNovo);



    },

    filialRetiradaItemAlterada: function (e) { // FNX-5270
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var codigoFilialRetiradaNovo = e.target.value;
        var codigoFilialRetiradaAnterior = this.model.get("CodigoFilialRetirada");
        if (codigoFilialRetiradaNovo !== codigoFilialRetiradaAnterior) {
            //$elementoComFocoEdicaoFilialRetiradaItemGrid = $(':focus');
            //$IndexEdicaoFilialRetiradaItemGrid = this.model.get("Index");

            this.model.set("CodigoFilialRetirada", codigoFilialRetiradaNovo)
        }
    },

    filialTransferenciaItemAlterada: function (e) { // FNX-5270
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var codigoFilialTransferenciaNovo = e.target.value;
        var codigoFilialTransferenciaAnterior = this.model.get("CodigoFilialTransferencia");
        if (codigoFilialTransferenciaNovo !== codigoFilialTransferenciaAnterior) {
            //$elementoComFocoEdicaoFilialTransferenciaItemGrid = $(':focus');
            //$IndexEdicaoFilialTransferenciaItemGrid = this.model.get("Index");

            this.model.set("CodigoFilialTransferencia", codigoFilialTransferenciaNovo)
        }
    },

    tipoFaturamentoItemAlterado: function (e) { // FNX-5270
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var codigoTipoFatNovo = e.target.value;
        var codigoTipoFatAnterior = this.model.get("CodigoFilialTransferencia");
        if (codigoTipoFatNovo !== codigoTipoFatAnterior) {
            //$elementoComFocoEdicaoTipoFatItemGrid = $(':focus');
            //$IndexEdicaoTipoFatItemGrid = this.model.get("Index");

            this.model.set("TipoFaturamento", codigoTipoFatNovo)
            global.unblockUI();
        }
    },

    centroCustoAlterado: function (e) { // FNX-4253
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }
        global.blockUI();
        var idClienteCentroCustoNovo = parseInt(e.target.value);
        var idClienteCentroCustoAnterior = this.model.get("IdClienteCentroCusto");
        if (idClienteCentroCustoNovo !== idClienteCentroCustoAnterior) {


            window.$elementoComFocoEdicaoCentroCustoItemGrid = $(':focus');
            window.$IndexEdicaoCentroCustoItemGrid = this.model.get("Index");

            this.model.set("IdClienteCentroCusto", idClienteCentroCustoNovo)
        }
    },

    quantidadeAlterada: function (e) {
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }

        global.blockUI();
        var quantidadeNova = e.target.value;
        if (this.parent.parent.itemOrcamentoView) {
            this.parent.parent.itemOrcamentoView.impedirAberturaModal = false; // FNX-5515
        }

        this.clearVariaveisPosicao();
        window.$elementoComFocoEdicaoQuantidadeItemGrid = $(':focus');
        window.$IndexEdicaoQuantidadeItemGrid = this.model.get("Index");

        this.model.set("Quantidade", quantidadeNova);
    },

    pedidoCompraAlterado: function (e) {
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }

        global.blockUI();
        var pedidoCompraNovo = e.target.value;

        this.clearVariaveisPosicao();
        window.$elementoComFocoEdicaoPedidoCompraItemGrid = $(':focus');
        window.$IndexEdicaoPedidoCompraItemGrid = this.model.get("Index");

        this.model.set("PedidoCompra", pedidoCompraNovo);
    },

    linhaOrdemCompraAlterado: function (e) {
        if (e) e.preventDefault();
        if (!this.model.get("AtualizarRemoto")) {
            return;
        }

        var linhaOrdemCompraNova = e.target.value;

        window.$elementoComFocoEdicaoLinhaOrdemCompraItemGrid = $(':focus');
        window.$IndexEdicaoLinhaOrdemCompraItemGrid = this.model.get("Index");


        this.model.set("PedidoCompraCliente", linhaOrdemCompraNova);
    },

    mostrarSubItens: function (e) {

        var aberto = this.model.get("subItensAberto");

        if (!aberto) {
            $("[subitem=" + this.model.get("CodigoTinta") + "]", this.$el.parent()).show();
            $("[subitem=" + this.model.get("CodigoTinta") + "]", this.$el.parent()).find('td:eq(1)').css('border-right', '2px dashed black');
        } else {
            $("[subitem=" + this.model.get("CodigoTinta") + "]", this.$el.parent()).hide();
        }

        // $("html, body")
        //     .animate({
        //             scrollTop: $(e.target).offset().top-100
        //         },
        //         500);

        this.model.set("subItensAberto", !aberto);

    },

    editarLotes: function (e) {

        this.lotesProdutoController = this.controller.showView({
            region: {
                name: "lotesItemOrcamentoRegion",
                selector: "#lotes-item-orcamento-region"
            },
            controller: {
                type: LotesProdutoController,
                args: {
                    orcamento: this.controller.model,
                    item: this.model,
                    codigoObjetoItem: this.model.get("Identificador"),
                    renderizarCallback: $.proxy(this.render, this)
                }
            }
        });

    },

    onShow: function () {
        if (this.acoes) {
            this.model.on("change:selecionado", this.render, this);
        } else {

            $("td[acoes]", this.$el).remove();

        }
        $("input").on('focus', function () { $(this).select(); });
        GridController.start(this.$el); // FNX-3819
    },

    ambienteAlterado: function (ambiente, cor, item) {

        this.controller.model.set("Ambiente", ambiente);
        this.controller.model.set("CorAmbiente", cor);
        this.model.set("Ambiente", ambiente);
        this.model.set("CorAmbiente", cor);

        if (!item) {
            this.render();
        } else {
            this.parent.alterarAmbientes(ambiente, cor, item);
        }

        this.parent.alterarAmbientesSelecionados(ambiente, cor);
        this.controller.habilitarBotoes();

        if (this.controller.ambientesSeparados) {
            this.controller.separarAmbientes();
        }
    },

    ambienteExcluido: function (item) {
        if (this.controller.model.get("Ambiente") == item.Ambiente) {
            this.controller.model.set("Ambiente", null);
            this.controller.model.set("CorAmbiente", null);
        }

        this.parent.excluirAmbiente(item);
        this.controller.habilitarBotoes();
    },

    selecionarItem: function (e) {

        if (this.orcamento.OrdemAlterada) {
            this.controller.validateBeforeToContinue();

            return;
        }

        if (!this.acoes) {
            return;
        }

        if (!$(e.target).is('td.selecionavel') && $(e.target).parents("td.selecionavel").length == 0) {
            return;
        }

        if (this.model.get("Classe") == "Itempedidovendasubordinado") {
            return;
        }

        var cor = $(e.target).parents("tr").css("background-color");

        if (e.clientX !== null) { // Click linha
            if (cor === "rgb(255, 255, 255)" || cor === "transparent" || cor === "rgba(0, 0, 0, 0)") {
                $(e.target).parents("tr").css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
                this.model.set("selecionado", true);
                store.dispatch(atualizarItemAction({identificador: this.model.get("Identificador"), dados: {selecionado: true}}))
            } else {
                $(e.target).parents("tr").css({ "background-color": '', "color": '' });
                this.model.set("selecionado", false);
                store.dispatch(atualizarItemAction({identificador: this.model.get("Identificador"), dados: {selecionado: false}}))
            }
        } else { //Selecionar Todos
            if (window.$boolSelecionarTodosItensOrcamento) {
                if (cor === usuarioLogado.CorFundo || cor === "transparent" || cor === "rgba(0, 0, 0, 0)") {
                    $(e.target).parents("tr").css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
                    this.model.set("selecionado", true);
                    store.dispatch(atualizarItemAction({identificador: this.model.get("Identificador"), dados: {selecionado: true}}))
                }
            } else {
                $(e.target).parents("tr").css({ "background-color": '', "color": '' });
                this.model.set("selecionado", false);
                store.dispatch(atualizarItemAction({identificador: this.model.get("Identificador"), dados: {selecionado: false}}))
            }
        }

        hackCorrigirProblemaAposSelecaoDeItens()

        this.itemSelecionado();
    },

    itemSelecionado: function (e) {

        if (!this.acoes) {
            return;
        }

        this.parent.habilitarBotoes();
    },

    editarItem: function (e) {
        this.parent.editarItem(this.model);
    },

    mostrarAmbientes: function (e) {

        if (!this.acoes) {
            return;
        }

        if (this.model.get("Classe") == "Itempedidovendasubordinado") {
            return;
        }

        if (this.orcamento.get("SomenteLeitura")) return;

        var trigger = $(e.target);

        if (!trigger.is("td")) {
            trigger = $(e.target).parents("td");
        }

        if (trigger.length == 0) {
            return;
        }

        this.menuAmbientes.show(trigger[0]);

    },

    showInfo: function () {

        this.itemOrcamentoInfoView = this.controller.showView({
            region: {
                name: "itemOrcamentoInfoViewRegion",
                selector: "#detalhe-item-orcamento-region"
            },
            view: {
                type: ItemOrcamentoInfoView,
                args: {
                    controller: this.controller,
                    model: this.model
                }
            }
        });
    },

    itemExcluido: function (data) {
        this.vendaProdutoEstoqueIndisponivel.hide();

        if (this.itemExcluidoCallback) {
            this.itemExcluidoCallback(data);
        }
    },
});

window.ItemOrcamentoItemView = ItemOrcamentoItemView

const ItemOrcamentoItemExpandidoView = Backbone.Marionette.ItemView.extend({
    name: "ItemOrcamentoItemExpandidoView",
    template: "#template-itens-orcamento-item-expandido",
    tagName: "tr",
    className: "clicavel",

    events: {
        'click td.selecionavel': "selecionarItem",
        'click a[editar]': "editarItem",
        'click a[info]': "showInfo",
        'click .ambiente-col': "mostrarAmbientes"
    },

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.acoes = typeof options.acoes !== "undefined" ? options.acoes : true;
        this.expandido = typeof options.expandido !== "undefined" ? options.expandido : false;
        this.controller = options.controller;

        this.menuAmbientes = new MenuAmbienteController({
            region: "#menu-ambientes",
            orcamento: options.controller.model,
            model: this.model,
            itemSaved: $.proxy(this.ambienteAlterado, this),
            itemDeleted: $.proxy(this.ambienteExcluido, this),
            readOnly: this.controller.readOnly
        });
    },

    render: function () {

        var self = this;

        var data = {
            view: this,
            quantidade: function () {
                return global.formatNumber(this.Quantidade, 4);
            },
            precoProduto: function () {
                return global.formatMoney(this.PrecoProduto);
            },
            valorTotal: function () {
                return global.formatMoney(this.ValorTotal);
            },
            quantidadeSolicitada: function () {
                return global.formatNumber(this.QuantidadeSolicitada, 3);
            },
            precoSolTotal: function () {
                return global.formatMoney(this.PrecoSolTotal);
            },
            quantidadePendente: function () {
                return global.formatNumber(this.QuantidadePendente, 3);
            },
            precoPendenciaTotal: function () {
                return global.formatMoney(this.PrecoPendenciaTotal);
            },
            cor: function () {
                if (!this.view) {
                    return null;
                }

                if (typeof this.Ambiente == "undefined" || !this.Ambiente) {
                    return this.view.menuAmbientes.undefinedColor;
                }

                return this.view.menuAmbientes.getColor(this.Ambiente);
            },
            ambiente: function () {
                return typeof this.Ambiente !== "undefined" && this.Ambiente ? this.Ambiente : "Definir";
            },
            dataPrevisaoEntrega: function () {
                return global.formatDate(this.DataPrevisaoEntrega);
            },
            dataMarcadaEntrega: function () {
                return global.formatDate(this.DataMarcadaEntrega);
            }
        };
        _.extend(data, this.model.toJSON());


        this.$el.html(Mustache.render($(this.template).html(), data));

        if (this.acoes) {

            if (this.model.get("selecionado")) {
                this.$el.css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });
            } else {
                this.$el.css({ "background-color": '', "color": '' });
            }
        }

    }

});

window.ItemOrcamentoItemExpandidoView = ItemOrcamentoItemExpandidoView

const ItemOrcamentoInfoView = Backbone.Marionette.ItemView.extend({
    template: "#template-itens-orcamento-info",

    initialize: function (options) {
        this.app = options.app,
            this.parent = options.parent,
            this.model = options.model;
        this.controller = options.controller;
        this.menuConsultaProdutosController = new MenuConsultaProdutosController({
            controller: this.controller,
            model: this.model
        });
    },

    onShow: function () {
        this.menuConsultaProdutosController.show();
    },

    onDestroy: function () {
        this.menuConsultaProdutosController.hide();
    }
});

window.ItemOrcamentoInfoView = ItemOrcamentoInfoView

const ItemOrcamentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-itens-orcamento",
    childView: ItemOrcamentoItemView,
    childViewContainer: "#lista-itens-orcamento-container",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.orcamento = options.orcamento;
        this.itemExcluidoCallback = options.itemExcluidoCallback;

        /**
         * a variavel impedirAberturaModal e a funcao obterEDarResetImpedirAberturaModal foram introduzidas
         * para resolver a FNX-5454.
         * quando a funcao adquirirQuantidadeTotalGridItens eh chamada ao clicar no ok do modal, sao disparados eventos que geram efeitos colaterais
         * por varios objetos fazendo a execucao chegar novamente na funcao obterEncomendaItemOrcamentoGidItens, que abria o modal de novo,
         * criando um efeito de loop
         *
         * como sempre, nao eh nem de longe a melhor solucao, mas foi o que deu pra fazer nesse front
         *
         * jonathan bispo - 2020-10-21
         */
        this.impedirAberturaModal = false
        this.obterEDarResetImpedirAberturaModal = function() {
            var valorAtual = this.impedirAberturaModal
            this.impedirAberturaModal = false
            return valorAtual
        }

        if (this.collection) {
            this.collection.on("change:Quantidade", this.render, this);
            this.collection.on("change:DataPrevisaoEntrega", this.render, this);
            this.collection.on("change:DataMarcadaEntrega", this.render, this);
            this.collection.on("change:DespesasInclusas", this.render, this);
            this.collection.on("change:OfertaSelecionada", this.render, this);
            this.collection.on("change:CodigoTipoEntrega", this.render, this);
            this.collection.on("change:DescricaoTipoEntrega", this.render, this);
            this.collection.on("change:TurnoEntrega", this.render, this);
            this.collection.on("change:ValorTotal", this.render, this);
            this.collection.on("change:Atualizar", this.render, this);
            this.collection.on("change:DescricaoProduto", this.render, this);
        }
        $(window).resize($.proxy(global.redimensionarModal, this, "#itens-orcamento-expandido-container", "#modalItensOrcamentoExpandido"));
        $(window).resize($.proxy(global.redimensionarModal, this, "#modalListarItens-container", "#modalListarItens"));

        //$('#selecionar-todos-itens-orcamento').click($.proxy(this.selecionarTodosItemOrcamento, this));
        parametroSistema.obter("TRATAR_VENDAS_SOB_ENCOMENDA",
            $.proxy(function (p) {
                this.parametroTratarVendaSobEncomenda = p;
            },
                this));
    },

    events: {
        'click #expandir-itens-orcamento': "expandir",
        'keydown #OrdemItemSelecao': "ordemItemSelecao"
    },

    buildChildView: function (item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.controller,
            expandido: false,
            orcamento: this.orcamento,
            itemExcluidoCallback: this.itemExcluidoCallback
        });

        if (this.controller) {
            view.controller = this.controller;
        }

        return view;
    },

    expandir: function () {

        if (this.app) {
            if (!this.app.getRegion("itensOrcamentoExpandidoRegion")) {
                this.app.addRegions({
                    itensOrcamentoExpandidoRegion: "#itens-orcamento-expandido-container"
                });
            }

            this.app.itensOrcamentoExpandidoRegion.reset();

            var itensOrcamentoExpandidoView = new ItensOrcamentoExpandidoView({
                app: this.app,
                controller: this.controller,
                collection: this.collection
            });

            this.controller.aplicarAspectos(itensOrcamentoExpandidoView);

            this.app.itensOrcamentoExpandidoRegion.show(itensOrcamentoExpandidoView);

            global.redimensionarModal("#itens-orcamento-expandido-container", "#modalItensOrcamentoExpandido")
            $("#modalItensOrcamentoExpandido").modal();


            $(".modal-backdrop").css("z-index", "-1");
        }
    },

    ordemItemSelecao: function (e) {
        e?.preventDefault?.();

        const self = this;
        const valorNovo = $(e.target).val() + e.key ? parseInt($(e.target).val() + e.key) : undefined;
        var qtdeItens = this.orcamento.get('ItensOrcamento').length;

        if (valorNovo == undefined || valorNovo <= 0) {
            $(e.target).val('');
            return;
        }

        if (valorNovo > qtdeItens) {
            global.showErrorMessage('Valor não é uma opção válida!');
            $(e.target).val('');
            return;
        }

        if (e.keyCode === 9 || e.keyCode === 13) {

            $(e.target).val('');

            this.controller.removerSelecaoItens();

            var itemSelecao = $('span[name="OrdemItem"]').filter(function (i, e) { return $(e).text() === valorNovo.toString(); });
            document.documentElement.scrollTop = itemSelecao.offset().top - 300;

            itemSelecao.parents('tr').css({ "background-color": usuarioLogado.CorFundo, "color": usuarioLogado.CorTexto });

            this.collection.each(function (e, i) {
                if (e.get('Codigo') === itemSelecao.data('codigo-produto').toString()) {
                    e.set('selecionado', true);
                    store.dispatch(atualizarItemAction({identificador: e.get("Identificador"), dados: {selecionado: true}}))
                    self.parent.habilitarBotoes();
                }
            });
            return;
        }

        $(e.target).val(valorNovo);
    },

    editarItem: function (item) {
        this.parent.editarItem(item);
    },

    habilitarBotoes: function () {
        this.parent.habilitarBotoes();
    },

    selecionarTodosItemOrcamento: function (e) {

        if (window.$boolSelecionarTodosItensOrcamento)
            window.$boolSelecionarTodosItensOrcamento = false
        else
            window.$boolSelecionarTodosItensOrcamento = true

        $("#lista-itens-orcamento-container td.selecionavel.codigo").trigger("click")
    },

    alterarAmbientes: function (ambiente, cor, item) {

        this.collection.each(function (model) {

            var a = model.get("Ambiente");

            if (a && a == item.Ambiente) {
                model.set("Ambiente", ambiente);
                model.set("CorAmbiente", cor);
            }
        });

        this.children.each(function (view) {

            if (view.menuAmbientes) {
                view.menuAmbientes.updateItems(item.Ambiente, ambiente);
            }

        });

        this.render();
    },

    alterarAmbientesSelecionados: function (ambiente, cor) {

        this.children.each(function (view) {

            if (view.model.get("selecionado")) {
                view.model.set("Ambiente", ambiente);
                view.model.set("CorAmbiente", cor);
                view.render();
            }
        });

    },

    excluirAmbiente: function (item) {

        this.collection.each(function (model) {

            var a = model.get("Ambiente");

            if (a && a == item.Ambiente) {
                model.set("Ambiente", null);
                model.set("CorAmbiente", null);
            }
        });

        this.children.each(function (view) {

            if (view.menuAmbientes) {
                view.menuAmbientes.removeItem(item);
                view.render();
            }

        });

        if (this.controller.ambientesSeparados) {
            this.controller.separarAmbientes();
        }

    },


    obterEncomendaItemOrcamentoGidItens: function () {
        var self = this;
        if (window.$IndexEdicaoQuantidadeItemGrid < 1) {
            global.unblockUI();
            return;
        }
        if (this.collection && this.collection.models) { // FNX-5454
            var model = this.collection.models[window.$IndexEdicaoQuantidadeItemGrid - 1];
        }

        if (!model) {
            global.unblockUI();
            return;
        }

        if (!model.get("VendaSobEncomenda")) {
            global.unblockUI();
            return;
        }

        global.ajax({
            url: "/Orcamento/ObterEncomendaItemOrcamento",
            type: "post",
            data: {
                identificadorOrcamento: model.get("IdentificadorOrcamento"),
                identificador: model.get("Identificador")
            },
            error: function () { global.unblockUI(); },
            success: function (data) {
                if (self.obterEDarResetImpedirAberturaModal() == false) {
                self.mostrarModalEncomendaGridItens(data, model);
                }

                global.unblockUI();
            }
        });
    },
    mostrarModalEncomendaGridItens: function (data, model) {
        $modelSobEncomendaGridItens = null;
        if (data &&
            model.get("VendaSobEncomenda") &&
            this.parametroTratarVendaSobEncomenda &&
            this.parametroTratarVendaSobEncomenda.Valor !== "4") {

            $modelSobEncomendaGridItens = model;

            data.AdquirirQuantidadeTotalItem = model.get("AdquirirQuantidadeTotal");
            data.ParametroTratarVendaSobEncomenda = this.parametroTratarVendaSobEncomenda;
            data.EncomendaAutomatica = model.get("EncomendaAutomatica");
            data.habilitarAdquirirQuantidadeTotal = function () {
                // FNX-979
                if (this.ParametroTratarVendaSobEncomenda.Valor == "4" ||
                    this.QuantidadeDisponivel <= 0)
                    return false;
                else {
                    return data.EncomendaAutomatica;
                }

            };
            data.adquirirQuantidadeTotal = $.proxy(this.adquirirQuantidadeTotalGridItens, this);
            data.cancelar = $.proxy(this.cancelarModalEncomenda, this);
            this.controller.applyBindings(data, $("#modalVendaSobEncomendaGridItens")[0]);

            $("#modalVendaSobEncomendaGridItens").modal("show");
            //$('.modal-backdrop').css('z-index', '-1');
        }
    },
    adquirirQuantidadeTotalGridItens: function (model) {

        if ($modelSobEncomendaGridItens !== null) {
            $modelSobEncomendaGridItens.set("AdquirirQuantidadeTotal", model.AdquirirQuantidadeTotalItem);
            this.impedirAberturaModal = true
            $modelSobEncomendaGridItens.adquirirQuantidadeTotalAlterado();
        }

        $("#modalVendaSobEncomendaGridItens").modal("hide");
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();

        //if (this.finalizarEdicaoItemCallback) {
        //    this.finalizarEdicaoItemCallback();
        //}
        $modelSobEncomendaGridItens = null;

    },
    cancelarModalEncomenda: function () {

        if (this.ui && this.ui.vendaSobEncomenda) {
            this.ui.vendaSobEncomenda.prop("checked", false);
        }

        $modelSobEncomendaGridItens = null;
    },

});

window.ItemOrcamentoView = ItemOrcamentoView

const ItemOrcamentoItemViewOrdenacao = Backbone.Marionette.ItemView.extend({
    name: "ItemOrcamentoItemViewOrdenacao",
    template: "#template-itens-orcamento-item-ordenacao",
    tagName: "tr",
    className: "clicavel",

    events: {
        'change input[name="OrdItem"]': "ordenacaoItemAlterada"
    },

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.controller = options.controller;
        this.orcamento = options.orcamento;
    },

    render: function () {



        var self = this;

        var data = {
            view: this,
            quantidade: function () {
                return global.formatNumber(this.Quantidade, 3);
            },
            precoProduto: function () {
                return global.formatMoney(this.PrecoProduto);
            },
            valorTotal: function () {
                return global.formatMoney(this.ValorTotal);
            },
            quantidadeSolicitada: function () {
                return global.formatNumber(this.QuantidadeSolicitada, 3);
            },
            precoSolTotal: function () {
                return global.formatMoney(this.PrecoSolTotal);
            },
            quantidadePendente: function () {
                return global.formatNumber(this.QuantidadePendente, 3);
            },
            precoPendenciaTotal: function () {
                return global.formatMoney(this.PrecoPendenciaTotal);
            },
        };

        _.extend(data, self.model.toJSON());

        this.$el.html(Mustache.render($(this.template).html(), data));
    },

    ordenacaoItemAlterada: function (e) {
        if (e) e.stopPropagation();

        const valorNovo = e.target.value ? parseInt(e.target.value) : undefined;
        var valorAnterior = this.model.get("OrdemItem");
        var qtdeItens = this.orcamento.get('ItensOrcamento').length;

        if (valorNovo == undefined || valorNovo > qtdeItens || valorNovo < 0) {
            global.showErrorMessage('Valor não é uma opção válida!');
            e.target.value = valorAnterior;
            return;

        } else {
            e.target.value = valorNovo;

        }

        this.model.set("OrdemItemAnterior", valorAnterior);
        this.model.set("OrdemItem", valorNovo);


    }
});

window.ItemOrcamentoItemViewOrdenacao = ItemOrcamentoItemViewOrdenacao

const ItemOrcamentoViewOrdenacao = Backbone.Marionette.CompositeView.extend({
    template: "#template-itens-orcamento-ordenacao",
    childView: ItemOrcamentoItemViewOrdenacao,
    childViewContainer: "#lista-itens-orcamento-container-ordenacao",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.orcamento = options.orcamento;
    },

    events: {

    },

    buildChildView: function (item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.controller,
            orcamento: this.orcamento
        });

        if (this.controller) {
            view.controller = this.controller;
        }

        return view;
    },

    onShow: function () {
        this.setFocus();
    },

    refresh: function () {

        var self = this;

        self.collection = self.orcamento.get("ItensOrcamento");
        new Promise<void>(function (resolve) {
            self.render();
            resolve();

        }).then(function () {
            self.setFocus();
            if (self.orcamento.OrdemItemFoco) {

                $('input[name="OrdItem"]').filter(function (i, e) {
                    if (e.value === self.orcamento.OrdemItemFoco.toString()) {
                        setTimeout(function () { e.focus(); }, 100);
                    }
                });

            }
        });
    },

    setFocus: function () {
        $('input[name="OrdItem"]').on('focus', function () { $(this).select(); });
    }

});

window.ItemOrcamentoViewOrdenacao = ItemOrcamentoViewOrdenacao

const ItensOrcamentoExpandidoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-itens-orcamento-expandido",
    childView: ItemOrcamentoItemExpandidoView,
    childViewContainer: "#lista-itens-orcamento-expandido-container",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.controller = options.controller;
    },

    buildChildView: function (item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.controller,
            acoes: false,
            expandido: true
        });

        if (this.controller) {
            view.controller = this.controller;
        }
        GridController.start(this.$el);
        return view;
    }
});

window.ItensOrcamentoExpandidoView = ItensOrcamentoExpandidoView

const AmbienteView = Backbone.Marionette.CompositeView.extend({
    template: "#template-ambiente",
    tagName: "li",
    childView: ItemOrcamentoView,
    childViewContainer: "[itens-orcamento-container]",

    buildChildView: function (item, itemView) {

        var collection = this.controller.model.obterItensAmbiente(item.get("Ambiente"));

        var view = new itemView({
            model: item,
            collection: collection,
            app: this.app,
            parent: this.controller,
            orcamento: this.orcamento,
            controller: this.controller
        });

        if (this.controller) {
            view.controller = this.controller;
        }

        return view;
    },

    onShow: function () {

        var template = $("#template-total-ambiente").html();

        var item = {
            quantidade: global.formatNumber(this.model.get("Quantidade"), 3),
            precoTotal: global.formatMoney(this.model.get("PrecoTotal")),
            quantidadeSolicitada: global.formatNumber(this.model.get("QuantidadeSolicitada"), 3),
            precoSolTotal: global.formatMoney(this.model.get("PrecoSolTotal")),
            quantidadePendente: global.formatNumber(this.model.get("QuantidadePendente"), 3),
            precoPendenciaTotal: global.formatMoney(this.model.get("PrecoPendenciaTotal"))
        };

        $("table", this.$el).first().append(Mustache.render(template, item));
        $("table", this.$el).attr("showActionButtons", "false");

        GridController.start(this.$el);
    }

});

window.AmbienteView = AmbienteView

const AmbientesView = Backbone.Marionette.CompositeView.extend({
    template: "#template-ambientes",
    childView: AmbienteView,
    childViewContainer: "#ambientes-container",

    initialize: function (options) {
        this.app = options.app;
        this.parent = options.parent;
        this.orcamento = options.orcamento;
    },

    buildChildView: function (item, itemView) {

        var collection = new Ambientes(item);

        var view = new itemView({
            model: item,
            collection: collection,
            app: this.app,
            parent: this,
            controller: this.controller,
            orcamento: this.orcamento
        });

        if (this.controller) {
            view.controller = this.controller;
        }
        GridController.start(this); // FNX-3819
        return view;
    }



});

window.AmbientesView = AmbientesView

export {
    ItemOrcamentoItemView,
    ItemOrcamentoItemExpandidoView,
    ItemOrcamentoInfoView,
    ItemOrcamentoView,
    ItemOrcamentoItemViewOrdenacao,
    ItemOrcamentoViewOrdenacao,
    ItensOrcamentoExpandidoView,
    AmbienteView,
    AmbientesView
}
